// import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Col,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { ServerPath } from "../../Constant";
import Form from "react-bootstrap/Form";
import ReportModal from "./ReportModal";
import cookieUtils from "../../utils/cookieUtils";
import { set } from "date-fns";
import { _axios } from "../../utils/axios";

const UpdateListing = (props) => {
  let myString = props?.data?.images;
  let myArray = myString.split(",");
  const [imageUrlString, setImageUrlString] = useState(myString);
  const [status, setStatus] = useState(props?.data?.status);
  const [reportModal, setReportModal] = React.useState(false);
  const [rejectModal, setRejectModal] = React.useState(false);
  const [report, setReport] = useState(",");
  const input = useRef(null);
  const [reportList, setReportList] = useState();
  const [imageUrl, setImageUrl] = useState(myArray[0]);
  const [show, setShow] = useState(false);
  const [listingNameHin, setListingNameHin] = useState(props?.data?.listing_name_hin)
  const [listingNameMar, setListingNameMar] = useState(props?.data?.listing_name_mar)
  const [listingNameGuj, setListingNameGuj] = useState(props?.data?.listing_name_guj)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleReport = (value) => {
    if (value === "") { }
    else {
      setReportModal(true);
      setReport(value);
    }
  };
  const user = cookieUtils.getSecureCookie('user');
console.log('Decrypted User Cookie:', user.name);
//  const handleSubmit = async () => {
//   try {
//     await axios.patch(`${ServerPath}/volunteer-essentials/admin`, {
//       status,
//       listing_id: props?.data?.listing_id,
//       user_id: props?.data?.user_id,
//       user_name: user.name,
//       listing_name_hin: listingNameHin,
//       listing_name_mar: listingNameMar,
//       listing_name_guj: listingNameGuj,
//     });
//     setShow(false);
//     window.location.reload();
//   } catch (error) {
//     console.error("Error updating list:", error);
//   }
// };
const handleSubmit = async () => {
  try{
  if (!props?.data?.listing_id || !user?.name) {
    console.error("Missing required fields");
    return;
  }

  const payload = {
    status: status,
    listing_id: props.data.listing_id,
    user_id: props.data.user_id,
    listing_name_hin: listingNameHin,
    listing_name_mar: listingNameMar,
    listing_name_guj: listingNameGuj,
    user_name: user.name,
  };

  console.log("Sending Payload:", payload);

    const response = await _axios.patch(`${ServerPath}/volunteer-essentials/admin`, payload);
    
    if (response.status === 200) {
      setShow(false);
      window.location.reload(); 
    }
  } catch (error) {
    // 2. Log the response error specifically
    console.error("Server Error:", error.response?.data || error.message);
  }
}
 const handleCover = (value) => {
  // 1. Split the string into an array
  let imageUrls = imageUrlString.split(",");

  // 2. Find the index of the selected image (value)
  const selectedIndex = imageUrls.indexOf(value);

  // 3. If the image is found and not already at index 0
  if (selectedIndex > -1 && selectedIndex !== 0) {
    // Remove the selected image from its current position
    const [selectedImage] = imageUrls.splice(selectedIndex, 1);

    // Add it to the beginning of the array
    imageUrls.unshift(selectedImage);
  }

  // 4. Join the array back into a comma-separated string
  const updatedImageUrlString = imageUrls.join(",");

  // 5. Update your state with the new string
  setImageUrlString(updatedImageUrlString);

  // You can also call setImageUrl(value) if you need the selected image URL for immediate display
  setImageUrl(value);
};

  const handleReject = () => {
    setRejectModal(true);
  };
  const handleRejectSubmit = async () => {
    try {
      const response = await _axios.patch(
        `${ServerPath}/volunteer-essentials/rejected-by-admin`,
        {
          rejection_reason: input.current.value,
          listing_id: props?.data?.listing_id,
          modified_by : user.name
        }
      );
      console.log(response);
      setRejectModal(false);
      setShow(false);
      window.location.reload();
    } catch (error) {
      console.error("Error updating list:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `${ServerPath}/listing-reports/${props?.data?.user_id}`;
        const response = await _axios.get(url);
        const actualData = response?.data?.data;
        setReportList(actualData);
        // Filter data based on status
      } catch (error) {
        console.error("Error fetching reports:", error);
      }
    };
    fetchData();
  }, []);

 
  return (
    <>
      {props.name ? (
        <a
          onClick={handleShow}
          className="text-decoration-none float-end"
          style={{ cursor: "pointer" }}
        >
          {props.name}
        </a>
      ) : (
        <a
          onClick={handleShow}
          className="text-decoration-none float-end"
          style={{ cursor: "pointer" }}
        >
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-top`} style={{ color: "black" }}>
                Update Listing
              </Tooltip>
            }
          >
            <button
              className="btn-square btn mx-2"
              style={{ backgroundColor: "#A020F0" }}
            >
              <i className="icon-reload" style={{ color: "white" }}></i>
            </button>
          </OverlayTrigger>
        </a>
      )}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Listing</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: "calc(100vh - 210px)",
            overflowY: "auto",
          }}
        >
          <Form>
            <Row className="g-3">
          <Form.Label className="fs-5">Volunteer Details</Form.Label>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Listing Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.listing_name}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Listing Name Hindi</Form.Label>
                  <Form.Control
                    type="text"
                    value={listingNameHin}
                    onChange={(e)=> setListingNameHin(e.target.value)}
                    // placeholder={props?.data?.listing_name}
                   
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Listing Name Marathi</Form.Label>
                  <Form.Control
                    type="text"
                    value={listingNameMar}
                    onChange={(e)=> setListingNameMar(e.target.value)}
                    // placeholder={props?.data?.listing_name}
                    
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Listing Name Gujarati</Form.Label>
                  <Form.Control
                    type="text"
                    value={listingNameGuj}
                    onChange={(e)=> setListingNameGuj(e.target.value)}
                    // placeholder={props?.data?.listing_name}
                   
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Volunteer Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.user_name}
                    disabled
                  />
                </Form.Group>
              </Col>
              {String(props?.data?.contact_details).length > 6 && <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Owner Contact Details</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.contact_details}
                    disabled
                  />
                </Form.Group>
              </Col>}
              <Col md={6}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Detail Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={`${props?.data?.flat_number !== '' ? props?.data?.flat_number + ',' : ''} ${props?.data?.street_address !== '' ? props?.data?.street_address + ',' : ''} ${props?.data?.nearby_landmark !== '' ? props?.data?.nearby_landmark + ',' : ''} ${props?.data?.city !== '' ? props?.data?.city + ',' : ''} ${props?.data?.district !== '' ? props?.data?.district + ',' : ''} ${props?.data?.state !== '' ? props?.data?.state + ',' : ''} ${props?.data?.pincode}`}
                     //"A-34, Flat-3, Sai housing society, Gurudwara Chouk, Omkareshwar, Madhya Pradesh 451115"
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Latitude</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.latitude}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Longitude</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.longitude}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Status</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={props?.data?.status}
                    // value={bloodGroup}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option selected disabled value={null}>
                      {"Select Status"}
                    </option>
                    <option value="0">{"Pending"}</option>
                    <option value="1">{"Active"}</option>
                    <option value="2">{"Deactivate"}</option>
                    <option value="3">{"Reported"}</option>
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label style={{ color: "red" }}>Reports</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue="Select"
                    // value={bloodGroup}
                    onChange={(e) => { handleReport(e.target.value); }}
                  >
                    <option value="">{`Select Report`}</option>
                    {reportList &&
                      reportList.map((report, index) => {
                        return (
                          <option
                            key={index}
                            value={`${report.reporting_type},${report.reporting_text}`}
                          >
                            {`Report ${index}`}
                          </option>
                        );
                      })}
                  </select>
                  <ReportModal
                    report={report}
                    show={reportModal}
                    onHide={() => setReportModal(false)}
                  />
                </Form.Group>
              </Col>
              <Row style={{ marginTop: "20px", left: "-2px" }}>
                <Col md={3}>
                  <Form.Group controlId="formGridUserName">
                    <Form.Label>Image</Form.Label>
                    <select
                      name="select"
                      class="form-control form-select form-select"
                      defaultValue={null}
                      onChange={(e) => handleCover(e.target.value)}
                    >
                    {/* <Form.Text>You can change cover photo by setting the photo</Form.Text> */}
                      {/* <option value={imageUrl}>
                        {`Listing ${props?.data?.images}`}
                      </option> */}
                      {myArray &&
                        myArray.map((image, index) => {
                          return (
                            <option key={index} value={image}>
                              {`Image ${index}`}
                            </option>
                          );
                        })}
                    </select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                  <Form.Label>Cover Photo</Form.Label>
                    <img
                      style={{
                        width: "300px",
                        height: "200px",
                        borderRadius: "6px",
                        border: "1px solid black",
                      }}
                      src={imageUrl}
                    />
                  </Form.Group>
                </Col>
                <Col md={5} style={{marginLeft:'50px'}}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Listing Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.listing_description}
                    disabled
                  />
                </Form.Group>
              </Col>
              </Row>
              </Row>
              {props?.data?.accomodation === 1 && <Row className="g-3">
          <Form.Label className="fs-5 mt-5">Accommodation Details</Form.Label>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Accomodation Type</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.accomodation_type}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>What type of place will guest have?</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.place_type}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    What kind of bathroom are available to guest?
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.accomodation_bathroom}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Max. Guest Capacity</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder={props?.data?.max_guest_capacity}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Total no. of rooms</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder={props?.data?.number_of_rooms}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Total no. of beds</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder={props?.data?.number_of_beds}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Is this facility open for 24/7?</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={props?.data?.open_24_hours}
                    disabled
                  >
                    <option value="1">{"Yes"}</option>
                    <option value="0">{"No"}</option>
                  </select>
                </Form.Group>
              </Col>
              {props?.data?.open_24_hours === 0 && <>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Check in Time</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.check_in_time}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Check out Time</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.check_out_time}
                    disabled
                  />
                </Form.Group>
              </Col>
              </>}
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Locks and Safety Does every room have a lock?</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={props?.data?.locks_on_room}
                    disabled
                  >
                    <option value="1">{"Yes"}</option>
                    <option value="0">{"No"}</option>
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Who else might be there ?</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.who_else_might_be_there}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Other Sevas</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.other_amenities}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>}
            {props?.data?.food === 1 && <Row className="g-3" >
          <Form.Label className="fs-5 mt-5">Food Details</Form.Label>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Type of Meals Provided & Timings</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.type_of_meals}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Does this facility offer Sadavrat (Self-Cooking Ration)?</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={props?.data?.sadavrat}
                    disabled
                  >
                    <option value="1">{"Yes"}</option>
                    <option value="0">{"No"}</option>
                  </select>
                </Form.Group>
              </Col>
              {props?.data?.sadavrat === 1 && <>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Sadavrat Items Provided</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.sadavrat_item}
                    disabled
                  />
                </Form.Group>
              </Col>
              {props?.data?.sadavrat_other !=='' && <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Any other Sadavrat Items Provided?</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.sadavrat_other}
                    disabled
                  />
                </Form.Group>
              </Col>}
              </>}
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Special Diet Availability</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.special_diet}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Beverages Served</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.berverages}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Approximate Number of People Served Daily?</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.max_people_served}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Seating Arrangements</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.seating_arrangement}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Is Prior Registration Required for Volunteer?</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={props?.data?.prior_registrration}
                    disabled
                  >
                    <option value="Yes">{"Yes"}</option>
                    <option value="No">{"No"}</option>
                    <option value="Good to Have">{"Good to Have"}</option>
                  </select>
                </Form.Group>
              </Col>
              {props?.data?.special_instruction !=='' && <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Any Special Instruction for Visitors</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.special_instruction}
                    disabled
                  />
                </Form.Group>
              </Col>}
            </Row>}

            {props?.data?.drinking_water === 1 && <Row className="g-3" >
          <Form.Label className="fs-5 mt-5">Drinking-Water Details</Form.Label>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Source of water</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.source_of_water}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Purification Method Used</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.purification_method}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>How is water Served?</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.how_water_served}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Hot or Boiled Water Available on request?</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={props?.data?.boiled_water_available}
                    disabled
                  >
                    <option value="1">{"Yes"}</option>
                    <option value="0">{"No"}</option>
                  </select>
                </Form.Group>
              </Col>
            </Row>}

            {props?.data?.bathrooms_toilets === 1 && <Row className="g-3" >
          <Form.Label className="fs-5 mt-5">Bathroom-Toilet Details</Form.Label>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Bathroom Type</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.bathroom_type}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Is it Women-Friendly</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.is_women_friendly}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Additional Info.</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.additional_info_bathroom}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>}

            {props?.data?.ghats === 1 && <Row className="g-3" >
          <Form.Label className="fs-5 mt-5">Ghat Details</Form.Label>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Ghat Type</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.ghat_type}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Is it Historic or Recently Developed?</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.historic_or_recently_developed}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Ghat Condition</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.ghat_condition}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Safety Measures Present</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.ghat_safety_measures}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Is the Ghat Well-Lit at Night</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={props?.data?.ghat_well_lit_night}
                    disabled
                  >
                    <option value="1">{"Yes"}</option>
                    <option value="0">{"No"}</option>
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Availability of Changing/Rest Rooms</Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={props?.data?.ghat_changing_room}
                    disabled
                  >
                    <option value="1">{"Yes"}</option>
                    <option value="0">{"No"}</option>
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Seating Areas & Shelters</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.ghat_seating_area_shelters}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Ghat Cleanliness Level</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.ghat_cleanliness_level}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Waste Management Facilities</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.ghat_waste_management}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Water Quality (as per recent observation)</Form.Label>
                  <Form.Control
                    as="textarea"
                    row={2}
                    placeholder={props?.data?.ghat_water_quality}
                    disabled
                  />
                </Form.Group>
              </Col>
              {props?.data?.ghat_special_instructions !== '' && <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>Ghat Special Instructions or Rules</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={props?.data?.ghat_special_instructions}
                    disabled
                  />
                </Form.Group>
              </Col>}
            </Row>}

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ width: "150px", color: "white" }}
            form="AddUserForm"
            variant="danger"
            type="submit"
            onClick={handleReject}
          >
            Reject
          </Button>

         {props.data.status === 0 ? <Button
            style={{ width: "150px", color: "white" }}
            form="AddUserForm"
            variant="warning"
            type="submit"
            onClick={handleSubmit}
          >
           Approve
          </Button> :   <Button
            style={{ width: "150px", color: "white" }}
            form="AddUserForm"
            variant="primary"
            type="submit"
            onClick={handleSubmit}
          >
           Update 
          </Button>}


          <Modal
            show={rejectModal}
            onHide={() => setRejectModal(false)}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Reject Listing
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6 style={{ display: "flex" }}>
                Reject Reason <h6 style={{ color: "red" }}>*</h6>
              </h6>
              <input
                style={{ width: '250px', border: '2px', padding: '5px', borderStyle: 'solid', borderColor: 'black', borderRadius: 10 }}
                type="text"
                placeholder="Reason"
                ref={input}
              ></input>
            </Modal.Body>
            <Modal.Footer>
              <Button
                style={{ width: "100px", color: "white" }}
                variant="warning"
                onClick={() => setRejectModal(false)}
              >
                Cancel
              </Button>
              <Button
                style={{ width: "100px", color: "white" }}
                variant="danger"
                onClick={handleRejectSubmit}
              >
                Deactivate
              </Button>
            </Modal.Footer>
          </Modal>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateListing;
